<template>
    <div class="left-header">
        <!--<img class="logo" src="@c/assets/img/fushima_logo_60.png" alt="DMS">-->
       
        <el-dropdown trigger="click">
            <span class="el-dropdown-link">
                <i class="el-icon-user"></i> 
                <template v-if="user">
                    <span> {{user.username}} </span>
                </template>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>

            <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                        v-if="user"
                        icon="el-icon-user" 
                        @click.native="$emit('openWindow',{id: user.user_id, name: 'Perfil', entidad: 'user', link:`${window.distributionapp.publicPath}/user/${user.user_id}`})">
                        Perfil
                    </el-dropdown-item>
                <el-dropdown-item icon="el-icon-switch-button" @click.native="logout()">Desconectar</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <!--<p class="time">{{ time }}</p>-->
        
        <!--<el-menu :collapse="true" v-if="user && user.menu && user.menu.length">
            <el-submenu index="1">
                <template slot="title">
                    <i class="el-icon-setting"></i>
                </template>
                <el-submenu v-for="(item,i) in user.menu" :key="i" :index="`1-${i}`">
                    <span slot="title">{{item.name}}</span>
                    <el-menu-item v-for="(option,o) in item.options" :key="o" :index="`1-${i}-${o}`" @click="goMenu(option.link)">{{option.name}}</el-menu-item>
                </el-submenu>
            </el-submenu>
        </el-menu>-->
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import moment from 'moment'

	export default {
        name: 'MenuHeader',
        data() {
            return {
                window,
                time: ''
            }
        },
        computed: {
            ...mapState({
				user: state => state.user.data
			})
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                //this.startTime()
            },
			logout () {
                this.$confirm('¿Seguro que desea cerrar sesión?', 'Desconectar', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('menu')
                    window.location.reload(true)
                })
            },
            goMenu(link) {
                this.openwindow(link,'_blank')
            },
            startTime() {

                let _self = this
                function _move (timeout = 60) {
                    _self.time = moment().format("DD/MM/YYYY, HH:mm")
                    setTimeout(() => {
                        _move();
                    }, timeout)
                }

                let segundos = moment().format("ss")
                if (segundos < 60) {
                    _move(60 - segundos)
                } else {
                    _move()
                }
                
            }
        }
	}
</script>

<style lang="scss">
.left-header {
    width: fit-content;
    align-items: center;
    display: flex;

    .el-dropdown-link {
        cursor: pointer;
        span {
            display: none;
            @media(min-width: 768px) { display: inline; }
        }
    }

    i.el-icon-arrow-down.el-icon--right {
        color: #ffffff6e;
    }

    span.el-dropdown-link.el-dropdown-selfdefine {
        color: white;
    }
}
</style>